module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/70446004563ddaa571a16dd126e17256.png";